import React from 'react';
import MiniHeaders from "./mini-headers";
import AccordionExpandIcon from "./acordion-expand";

const accordionData = [
    { id: 1, title: 'Ո՞վ է մենեջերը', content: 'Content for Accordion 1' },
    { id: 2, title: 'Ո՞վ է Վաճառողը', content: 'Content for Accordion 2' },
    { id: 3, title: 'Ինչպե՞ս գրանցվեմ դասընթացին', content: 'Content for Accordion 3' },
    { id: 4, title: 'Ի՞նչ գիտելիքներ են անհրաժեշտ', content: 'Content for Accordion 4' },
    { id: 5, title: 'Ինչքա՞ն են վաստակում մենեջերները', content: 'Content for Accordion 5' },
];

const Faq = () => {
    return (
        <div>
            <div className={'wrapper blocks-wrapper'}>
                <MiniHeaders headerName={'Հաճախ տրվող հարցեր'}/>
                <div>
                    <AccordionExpandIcon accordionData={accordionData} />
                </div>
            </div>
        </div>
    );
};

export default Faq;
